<script setup lang="ts">
import {IncludeCourse} from "@/types";
import {computed} from "vue";
import {useRouter} from "vue-router";

const props = defineProps<{
  item: IncludeCourse,
  darker: boolean;
}>()

const router = useRouter()

const shortInfo = computed(() => {
  return props.item.type === 2 ? `共${props.item.total_section}讲` :
      props.item.type === 1 ? `共${props.item.total_section}讲，每讲${props.item.duration}分钟` :
          ``
})

const emit = defineEmits(["onAdd", "onRemove"])

const onDeal = () => {
  if (props.item.is_type === 1) {
    props.item.is_type = 0
    emit("onRemove", props.item)
  } else {
    props.item.is_type = 1
    emit("onAdd", props.item)
  }
}

const detail = (id: number) => {
  const routeData = router.resolve({
    name: "CourseDetail",
    params: {
      id: id,
    }
  })
  window.open(routeData.href, "_blank")
}
</script>

<template>
  <div class="py-1rem px-1rem flex items-center" :class="darker? `bg-#fafafa` : `bg-white`">
    <el-image style="width: 5.3125rem; height: 3rem;" :src="item.thumb_image"/>
    <div class="flex-1 ml-1.5rem">
      <div class="text-#000000a6 text-.875em">{{ item.title }}</div>
      <div class="text-#00000073 text-.875em mt-.5rem">{{ shortInfo }}</div>
    </div>
    <div class="flex-1">
      <div class="text-#00000073 text-.875em">类型</div>
      <div class="text-#00000073 text-.875em mt-.5rem">{{
          item.type === 1 ? `直播课` : item.type === 2 ? `录播课` : `其他`
        }}
      </div>
    </div>
    <div class="flex-1">
      <div class="text-#00000073 text-.875em">单价</div>
      <div class="text-#00000073 text-.875em mt-.5rem">{{ item.price ? `￥${item.price}` : `免费` }}</div>
    </div>
    <div class="flex-1">
      <div class="text-#00000073 text-.875em">已购人数</div>
      <div class="text-#00000073 text-.875em mt-.5rem">{{ item.apply_size }}</div>
    </div>
    <div class="flex items-center">
      <el-button type="primary" plain class="mr-1.5rem" @click="detail(item.id)">详情</el-button>
      <el-button type="primary" :plain="item.is_type === 1" @click="onDeal">
        {{ item.is_type === 1 ? `取消添加` : `添加课程` }}
      </el-button>
    </div>
  </div>
</template>

<style scoped>
</style>
